import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'ppl-view-files',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './view-files.component.html',
  styleUrl: './view-files.component.css'
})
export class ViewFilesComponent {

}
